function Footer() {
    return (
        <footer className="footer">
            <p>Made with ❤️ by Promise Tshegofatso Magoga</p>
        </footer>
    )
}

export default Footer